import config from 'garaje/config/environment';
import { encodeJWTforJohnDoe } from 'garaje/mirage/helpers/auth';
import { getCookie, setCookie } from 'garaje/mirage/helpers/cookies';
import { Response } from 'miragejs';

import { addMinutes } from 'date-fns';

export default function () {
  // **************************************************************************
  // Authentication
  // **************************************************************************
  this.urlPrefix = config.apiHost;

  this.post('/a/auth/v0/token', function (schema, { requestBody }) {
    const body = JSON.parse(requestBody);
    const isPasswordRequest = body.grant_type === 'password';
    const isMfaRquest = body.grant_type === 'urn:envoy:grant_type:mfa';
    const accessToken = getCookie('access_token');
    const deviceGuid = getCookie('device_guid');

    // requests with invalid creds
    if (
      (isPasswordRequest && !['password', 'Password1'].includes(body.password)) ||
      (isMfaRquest && (body.challenge_code !== '123456' || accessToken !== 'mfa_jwt'))
    )
      return new Response(401, {}, { error: 'authorization_required' });

    if (isPasswordRequest && deviceGuid !== 'my_guid') {
      setCookie('access_token', 'mfa_jwt');
      return new Response(403, {}, { error: 'mfa_required' });
    }

    if (isMfaRquest && body.remember_device) setCookie('device_guid', 'my_guid');

    const jwt = encodeJWTforJohnDoe();

    setCookie('company_id', '1');
    setCookie('access_token', jwt);
    return { access_token: jwt, old_token: accessToken };
  });

  this.post('/a/mfa/challenge', function () {
    return new Response(200, {}, { challenge_code_expires_at: +addMinutes(new Date(), 5) });
  });
}
